import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../assets/scss/login-forms.scss";
import Header from "../../components/header/component";
import Footer from "../../components/footer/component";
import { useTranslation } from "react-i18next";
import { useGoogleLogin } from "@react-oauth/google";
import {
  DeleteTemplateDocId,
  GetEditorQueryInfo,
  saveUserAddress,
  signUpAsExternalUser,
  TrackEvent,
  updateUserGuid,
  VerifyCaptcha,
} from "../sign-up/actions";
import { validateSignupEmail, validateSignupPassword } from "../../validators/genericValidator";
import PathHelper, { getLinkWithLocale, redirectToDashboardWithLocale } from "../../utils/path-helper";
import { getSignInLink } from "../../utils/path-helper";
import i18next from "i18next";
import {
  APP_INSIGHT_ERROR,
  APP_INSIGHT_EVENT,
  APP_NAVIGATION,
  BasePortalCD,
  CategoryName,
  DomainName,
  EMPTY_GUID,
  invalidMailboxStatuses,
} from "../../utils/constants";
import {
  getTenantId,
  currentDomain,
  getGoogleCaptchaKey,
  getTenantGroupId,
  currentPortalCDForCaptcha,
  getTokenExIframeJs,
} from "../../utils/general-config";
import axios from "axios";
import {
  readCookie,
  createCookie,
  loadScript,
  removeScript,
  getIPConfig,
  isUserLoggedIn,
  UserDocMapping,
  getPortalCD,
  sendWelcomeEmail,
  PerquisiteBountyEnable,
  isAllAddressCookiePresent,
  checkQueryParams,
  isPricingPageFlow,
  buildPricingPageUrl,
  getDeviceType,
  currentPortalCD,
  getQueryParam,
} from "../../utils/helpers";
import CreateUUID from "../../utils/helpers";
import { trackEvents, trackEventsV2 } from "../../utils/tracking-events";
import { eventServicePost, loginAttempt, signUpUser, authUser, getAddress, getUserAbridged } from "./actions";
import { DomainEnum } from "../../services/enum/environment-enum";
import { generatePDFPath, getUserDocumentAttributes } from "../sign-in/actions";
import {
  getResumeBuildBaseURL,
  getPdfSimpliBaseURL,
  getSignSimpliBaseURL,
  getWorksimpliEndPoint,
  getLegalSimpliBaseURL,
} from "../../services/api-constants";
import ReactLoader from "../../components/resumebuild-loader/component";
import RBSignUp from "./rb";
import SignSimpliSignUp from "./ss";
import LegalSimpliSignUp from "./ls";
import {
  addWelcomeDocument,
  DocOperationJobStatusWithInterval,
  getDocOperationBlobData,
  ProcessDocOperationRequest,
  ProcessSignInRequest,
  ProcessSignUpRequest,
} from "../../utils/document-helper";
import { ConductABTest } from "../../utils/abtest-helper";
import { jwtDecode } from "jwt-decode";
import userServiceApi from "../../services/user-service-api";
import PSRSignUP from "./PSReskining/psr.js";
import SecureSimpliVerificationPopup from "../../components/secureSimpli-verification-popup/component";
import { saveMfaVerificationData, initiateMfa } from "../verify-user/actions";
import { createHmac, getTokenExID, getTokenExScheme, getUTCTimeStamp } from "../../utils/payment-config";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { clearIndexedDB } from "../../utils/helpers";

const SignUp = ({ funnelStep }) => {
  // useDataTrack("register");
  const recaptchaRef = useRef(null);
  const { locale } = useParams();
  let pathRedirect = PathHelper(APP_NAVIGATION.SINU);
  let signInLink = getSignInLink(locale, window.location.search);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [emailId, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState();
  const toggleLoader = (t) => setShowLoader(t);
  const [disableBtn, setdisableBtn] = useState(false);
  const [errorCount, setErrorCount] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const [showLoader, setShowLoader] = useState("d-none");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [termsOfUse, setTermsOfUse] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isCaptchaVisible, setIsCaptchaVisible] = useState(false);
  const [isCaptchaSuccessState, setIsCaptchaSuccessState] = useState(false);
  const [captchaTokenState, setCaptchaTokenState] = useState(null);
  const [captchaTimeState, setCaptchaTimeState] = useState(null);
  const [psscVerificationModal, setPsscVerificationModal] = useState(false);
  const togglePsscVerificationModal = (s) => setPsscVerificationModal(s);
  const [isSocialUserExists, setIsSocialUserExists] = useState(false);
  const [isGuestUser, setIsGuestUser] = useState(false);
  const [isLoggedInUser, setIsLoggedInUser] = useState(false);
  const portalCD = getPortalCD(locale);
  const isAllowedDomain = Object.keys(DomainEnum).some(
    (key) => key !== "WORKSIMPLI" && DomainEnum[key] === currentDomain(),
  );

  let PathRedirectDashboard = PathHelper(APP_NAVIGATION.DASH);

  let privacyLinksOption = PathHelper(APP_NAVIGATION.PRVY, false);
  let termsAndConditionOption = PathHelper(APP_NAVIGATION.TUSE, false);
  let subDomainParam;
  const isSecureSimpli =
    currentDomain() === DomainEnum.SIGNSIMPLI ||
    (currentDomain() === DomainEnum.PDFSIMPLI && getPortalCD(locale) === "PSSC");
  const isPSRB = currentDomain() === DomainEnum.PDFSIMPLI && getPortalCD(locale).indexOf("PSRB") > -1;
  const [otpTarget, setOtpTarget] = useState("");
  const toSetOtpTarget = (o) => setOtpTarget(o);
  const [userGuid, setUserGuid] = useState(null);
  const origin = window.location.origin;

  if (queryParams.has("q")) {
    // NOTE :: This query param will let us know from which sub domain, user is getting redirect from.
    subDomainParam = queryParams.get("q");
  }
  let domain = currentDomain().toLowerCase();
  const isTargetDomain = [DomainEnum.PDFSIMPLI, DomainEnum.WORKSIMPLI, DomainEnum.SIGNSIMPLI].includes(domain);
  const setUrls = (policy, terms, contact) => {
    setPrivacyPolicy(policy);
    setTermsOfUse(terms);
  };
  useEffect(() => {
    setUrls(privacyLinksOption.cstm, termsAndConditionOption.cstm);
  }, []);
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`, {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          })
          .then((res) => {
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        setLoginError(true);
        setLoginErrorMessage("Failed to login with google");
      }
    },
    onError: (errorResponse) => {
      setLoginError(true);
      setLoginErrorMessage("Failed to login with google");
      console.log(errorResponse);
    },
  });

  const appleLogin = async ({ user, authorization }) => {
    try {
      const { id_token: idToken } = authorization;
      if (!idToken) {
        setLoginError(true);
        // setLoginErrorMessage("Authorization token not found.");
        return;
      }
      const decodedToken = jwtDecode(idToken);
      const email = user?.email || decodedToken?.email;
      const fullName =
        user?.name?.firstName && user?.name?.lastName ? `${user.name.firstName} ${user.name.lastName}` : "";
      const sub = decodedToken?.sub;
      responseApple({ ...decodedToken, fullName }, authorization?.code);
    } catch (error) {
      console.error("Error during Apple login:", error);
      setLoginError(true);
      setLoginErrorMessage(error.message || "Failed to log in with Apple.");
    }
  };
  const handleCaptchaSuccess = async (token) => {
    setShowLoader("d-block");
    await TrackEvent(readCookie("userguid"), "Captcha_Clicked", emailId);

    try {
      let recaptchaScoreRequest = { greToken: token };
      const captchaResponse = await VerifyCaptcha(recaptchaScoreRequest, currentPortalCDForCaptcha());

      if (captchaResponse && captchaResponse.success) {
        setLoginError(false);
        onSignUp(captchaResponse.success, Date.now(), token);
      } else {
        setIsCaptchaSuccessState(false);
        setShowLoader("d-none");
      }
    } catch (err) {
      console.error("Signup after captcha failed", err);
      setShowLoader("d-none");
      setIsCaptchaSuccessState(false);
      setLoginError(true);
      setLoginErrorMessage(t("generic_error.inaction_message"));
    }
  };

  useEffect(() => {
    if (getGoogleCaptchaKey() != "") {
      loadScript("https://www.google.com/recaptcha/api.js?render=" + getGoogleCaptchaKey());
      trackEvents("signUpView", {
        visitId: readCookie("visitGuid"),
        userGuid: "",
        portalSource: getPortalCD(locale),
        eventLabel: "signUp View",
        email: "",
        firstName: "",
        lastName: "",
      });

      return () => {
        removeScript("https://www.google.com/recaptcha/api.js?render=" + getGoogleCaptchaKey());
      };
    }
  }, []);

  const isSignSimpliUser = () => {
    let semlCookie = readCookie("seml");
    if (!!semlCookie && semlCookie !== null && semlCookie !== "") {
      let validEmail = decodeURIComponent(semlCookie);
      setEmail(validEmail);
    }
  };
  useEffect(() => {
    if (queryParams.has("evp")) {
      isSignSimpliUser();
    }
    let isLoggedIn = isUserLoggedIn();
    if (isLoggedIn) {
      setShowLoader("d-block");
      getUserAbridged().then((response) => {
        if (!!response) {
          let isGuestUser = response && response?.roleNames?.includes("guest") ? true : false;
          setIsGuestUser(isGuestUser);
          setIsLoggedInUser(isLoggedIn);
          NavigationHandler(
            readCookie("userguid"),
            PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid),
            false,
            isGuestUser,
            isLoggedIn,
          );
        } else {
          NavigationHandler(readCookie("userguid"), false);
        }
      });
    }
    if (!isAllAddressCookiePresent()) {
      getIPConfig();
    }
  }, []);

  const onEmailChangeHandler = (e) => {
    setLoginError(false);
    setEmailError(false);
    setPasswordError(false);
    setIsCaptchaSuccessState(false);
    setIsCaptchaVisible(false);
    const {
      target: { value },
    } = e;
    setEmail(value);
  };
  const onPwdChangeHandler = (e) => {
    setLoginError(false);
    setPasswordError(false);
    setIsCaptchaSuccessState(false);
    setIsCaptchaVisible(false);
    const {
      target: { value },
    } = e;
    setPwd(value);
  };
  const onPasswordKeyPress = (e) => {
    const { charCode } = e;
    if (charCode === 13) {
      onSignUp();
    }
  };

  const onSignUp = async (captchaSuccess, captchaTime, captchaToken) => {
    setShowLoader("d-block");
    setLoginError(false);
    const isValid = validateData();
    if (!isValid) {
      setShowLoader("d-none");
      setdisableBtn(false);
      return;
    }

    if (isCaptchaVisible) {
      const tokenAge = Date.now() - (captchaTime || 0);

      if (!captchaSuccess || isCaptchaSuccessState || !captchaToken || tokenAge > 60000) {
        // setIsCaptchaSuccessState(false);
        setLoginError(true);
        setLoginErrorMessage(t("sign_up.im_not_robot"));
        setShowLoader("d-none");

        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        return;
      }
    }

    try {
      await new Promise((resolve) => window?.grecaptcha.ready(resolve));

      const token = await window?.grecaptcha.execute(getGoogleCaptchaKey(), {
        action: "register",
      });

      const loginAttemptReq = {
        emailAddress: emailId.trim(),
        ipAddress: readCookie("ipAddress"),
        attemptType: "Registration",
        visitorId: readCookie("visitorGuid"),
        visitId: readCookie("visitGuid"),
        createdBy: readCookie("visitorGuid"),
        portalCD: getPortalCD(locale),
        greCaptchaToken: token,
        isCaptchaRequired: true,
      };

      const loginResp = await loginAttempt(loginAttemptReq);

      if (loginResp && loginResp?.id !== EMPTY_GUID && loginResp.error === "") {
        const params = {
          email: emailId.trim(),
          password: pwd.trim(),
          portalCD: getPortalCD(locale),
          tenantId: getTenantId(subDomainParam),
          countryCD: readCookie("country"),
          currencyCD: readCookie("currency"),
          tenantGroupId: getTenantGroupId(),
          designVersion: "reskin",
        };

        let validUserGuid = readCookie("userguid");

        if (!isCaptchaVisible) {
          const signUpResp = await signUpUser(params);
          if (!signUpResp || !signUpResp.userGuid || !signUpResp.isValid) {
            setShowLoader("d-none");
            setdisableBtn(false);
            setLoginError(true);
            setPwd("");
            setLoginErrorMessage(
              domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI
                ? t("sign_up.email_already_taken")
                : t("sign_up.user_exists"),
            );
            return;
          }

          validUserGuid = signUpResp.userGuid;
          // setExistingUserGuid(signUpResp.userGuid);

          if (isAllowedDomain && invalidMailboxStatuses.includes(signUpResp?.emailVerificationSubStatus)) {
            await TrackEvent(validUserGuid, "Captcha_Viewed", emailId);
            setIsCaptchaVisible(true);
            setShowLoader("d-none");
            return;
          }
        }

        const authData = {
          Username: emailId.trim(),
          UserGuid: validUserGuid,
          Email: emailId.trim(),
        };

        const authResp = await authUser(authData, subDomainParam);
        await clearIndexedDB();
        if (!authResp) throw new Error("Auth failed");
        let data = {
          Id: CreateUUID(),
          UserId: validUserGuid,
          VisitorId: getQueryParam("extInstalledId") ? getQueryParam("extInstalledId") : readCookie("visitorGuid"),
          VisitId: readCookie("visitGuid"),
        };
        ConductABTest(authResp, params.portalCD, validUserGuid);
        await eventServicePost(data);
        await eventServicePost(data);
        const addResp = await getAddress(validUserGuid);
        if (addResp) {
          var addressReq = {
            UserGuid: validUserGuid,
            City: addResp[0],
            State: addResp[1],
            Country: addResp[2],
            ZipCode: addResp[3],
            AddressType: 0,
            IsActive: 1,
            TenantId: getTenantId(subDomainParam),
            ipAddress: addResp[4],
          };
          const addrSaveResp = await saveUserAddress(addressReq);
          if (addrSaveResp) {
            await handleSignupPostFlow(validUserGuid, params);
          }
        }
      } else {
        if (loginResp?.statusCode === 412) {
          setLoginErrorMessage(t("generic_error.Suspicious_Signup"));
        } else {
          setPwd("");
          setLoginErrorMessage(t("generic_error.max_Signup_attempt"));
        }
        setShowLoader("d-none");
        setLoginError(true);
        setdisableBtn(false);
      }
    } catch (error) {
      setPwd("");
      setLoginErrorMessage(t("generic_error.inaction_message"));
      setShowLoader("d-none");
      setLoginError(true);
      setdisableBtn(false);
      console.error(error);
    }
  };

  const handleSignupPostFlow = async (validUserGuid, params) => {
    try {
      await SignupSuccessEvent(validUserGuid, params.email);

      if (checkQueryParams(queryParams)) {
        setIsProcessing(true);

        const processResp = await ProcessSignUpRequest(queryParams, validUserGuid, false);
        if (processResp) {
          if (
            currentDomain() === DomainEnum.PDFSIMPLI ||
            currentDomain() === DomainEnum.WORKSIMPLI ||
            currentDomain() === DomainEnum.SIGNSIMPLI
          ) {
            if (!isPSRB) {
              await sendWelcomeEmail(validUserGuid, locale);
            }

            if (currentDomain() === DomainEnum.SIGNSIMPLI) {
              let userProfileResponse = await userServiceApi.getUserProfile(validUserGuid);
              let documentProfile = userProfileResponse.documentProfile || [];
              if (documentProfile.length === 0 || !documentProfile.some((doc) => doc.isWelcomeDocument)) {
                await addWelcomeDocument(validUserGuid);
              }
            }
          }
          if (isSecureSimpli) {
            setUserGuid(validUserGuid);
            const mfaData = {
              userGuid: validUserGuid,
              ipAddress: readCookie("ipAddress"),
              loginDeviceType: getDeviceType(),
              userAgent: navigator.userAgent,
              userAgentHash: "",
              macAddress: "",
              mfaRequired: true,
              mfaVerified: false,
              visitId: readCookie("visitGuid"),
              tenantId: getTenantId(),
            };
            await saveMfaVerificationData(mfaData);
            // await initiateMfa(validUserGuid);
            toSetOtpTarget("mfa");
            // Show the SecureSimpliVerificationPopup
            setShowLoader("d-none");
            togglePsscVerificationModal(true);
          } else {
            NavigationHandler(validUserGuid, false);
          }
        } else {
          setShowLoader("d-none");
          NavigationHandler(validUserGuid, false);
        }
      } else {
        if (isTargetDomain) {
          if (isSecureSimpli) {
            await sendWelcomeEmail(validUserGuid, locale);
            setUserGuid(validUserGuid);
            const mfaData = {
              userGuid: validUserGuid,
              ipAddress: readCookie("ipAddress"),
              loginDeviceType: getDeviceType(),
              userAgent: navigator.userAgent,
              userAgentHash: "",
              macAddress: "",
              mfaRequired: true,
              mfaVerified: false,
              visitId: readCookie("visitGuid"),
              tenantId: getTenantId(),
            };
            await saveMfaVerificationData(mfaData);
            toSetOtpTarget("mfa");
            // Show the SecureSimpliVerificationPopup
            setShowLoader("d-none");
            togglePsscVerificationModal(true);
          } else {
            if (!isPSRB) {
              await sendWelcomeEmail(validUserGuid, locale);
            }
          }
          if (domain !== DomainEnum.WORKSIMPLI && domain !== DomainEnum.PDFSIMPLI) {
            await addWelcomeDocument(validUserGuid);
          }
        }
        if (!isSecureSimpli) {
          NavigationHandler(validUserGuid, false);
        }
      }
    } catch {
      NavigationHandler(validUserGuid);
    }
  };

  const SignupSuccessEvent = (userGuid, email) => {
    return trackEventsV2("signUpSuccess", {
      visitId: readCookie("visitGuid"),
      userGuid: userGuid,
      portalSource: getPortalCD(locale),
      eventLabel: "signUp Success",
      email: email,
      firstName: "",
      lastName: "",
    });
  };
  const responseFacebook = (response) => {
    if (!!response && response.status != "unknown") {
      setShowLoader("d-block");
      setEmailError(false);
      const { name, email, id } = response;
      if (!!email) {
        const externalData = {
          createUser: {
            countryCD: readCookie("country"),
            currencyCD: readCookie("currency"),
            portalCD: getPortalCD(locale),
            parentUserGuid: "",
            firstName: name,
            lastName: "",
            company: "",
            title: "",
            email: email, //email
            password: "",
            tenantId: getTenantId(subDomainParam),
            tenantGroupId: getTenantGroupId(),
            designVersion: "reskin",
          },
          externalLoginInfo: {
            loginType: 1,
            providerKey: id, // "100732998798818",
          },
        };
        signUpAsExternalUser(externalData)
          .then((response) => {
            if (!!response) {
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
              createCookie("userguid", response.userGuid, 1);
              const authData = {
                Username: email.trim(),
                UserGuid: response.userGuid,
                Email: email.trim(),
              };
              setEmail(email.trim());
              authUser(authData, subDomainParam)
                .then(async (authResponse) => {
                  if (!!authResponse) {
                    await clearIndexedDB();
                    let data = {
                      Id: CreateUUID(),
                      UserId: response.userGuid,
                      VisitorId: readCookie("visitorGuid"),
                      VisitId: readCookie("visitGuid"),
                    };
                    eventServicePost(data).then((eventServiceResponse) => {});
                    if (response.isSocialUserExists === true) {
                      getAddress(response.userGuid).then((addResponse) => {
                        if (!!addResponse) {
                          var addressReq = {
                            UserGuid: response.userGuid,
                            City: addResponse[0],
                            State: addResponse[1],
                            Country: addResponse[2],
                            ZipCode: addResponse[3],
                            AddressType: 0,
                            IsActive: 1,
                            TenantId: getTenantId(subDomainParam),
                            IpAddress: addResponse[4],
                          };
                          saveUserAddress(addressReq).then((addressResponse) => {
                            if (!!addressResponse) {
                              SignupSuccessEvent(response.userGuid, email.trim())
                                .then((eventTrackResponse) => {
                                  if (checkQueryParams(queryParams)) {
                                    setIsProcessing(true);
                                    ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                      (processResponse) => {
                                        if (!!processResponse) {
                                          console.log("Process response and navigate...");
                                          if (!!isPerquisiteBountyEnable) {
                                            setIsSocialUserExists(response.isSocialUserExists);
                                            NavigationHandler(
                                              response.userGuid,
                                              isPerquisiteBountyEnable,
                                              response.isSocialUserExists,
                                            );
                                          } else {
                                            NavigationHandler(response.userGuid);
                                          }
                                        } else {
                                          console.log("error at process response...");
                                          setShowLoader("d-none");
                                          setdisableBtn(false);
                                          setLoginError(true);
                                          setLoginErrorMessage(t("generic_error.inaction_message"));
                                          NavigationHandler(response.userGuid);
                                        }
                                      },
                                    );
                                  } else {
                                    setIsSocialUserExists(response.isSocialUserExists);
                                    // Direct Sign up
                                    if (!!isPerquisiteBountyEnable) {
                                      NavigationHandler(
                                        response.userGuid,
                                        isPerquisiteBountyEnable,
                                        response.isSocialUserExists,
                                      );
                                    } else {
                                      NavigationHandler(
                                        response.userGuid,
                                        isPerquisiteBountyEnable,
                                        response.isSocialUserExists,
                                      );
                                    }
                                  }
                                })
                                .catch(() => {
                                  console.log(" Exception Sign up");
                                  NavigationHandler(response.userGuid);
                                });
                            } else {
                              //if response part of saveuseraddress api
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                              // logging
                            }
                          }); //saveuseraddress api
                        } else {
                          //if response part of getaddress api
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                        }
                      });
                      //get address api
                    } else {
                      ConductABTest(response, externalData.createUser.portalCD, response.userGuid);
                      getAddress(response.userGuid).then((addResponse) => {
                        if (!!addResponse) {
                          var addressReq = {
                            UserGuid: response.userGuid,
                            City: addResponse[0],
                            State: addResponse[1],
                            Country: addResponse[2],
                            ZipCode: addResponse[3],
                            AddressType: 0,
                            IsActive: 1,
                            TenantId: getTenantId(subDomainParam),
                            IpAddress: addResponse[4],
                          };
                          saveUserAddress(addressReq).then((addressResponse) => {
                            if (!!addressResponse) {
                              SignupSuccessEvent(response.userGuid, email.trim())
                                .then(async (eventTrackResponse) => {
                                  if (checkQueryParams(queryParams)) {
                                    setIsProcessing(true);
                                    ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                      async (processResponse) => {
                                        if (!!processResponse) {
                                          //ToDo: No need to check domain here. It can be managed within single email function.
                                          if (isSecureSimpli) {
                                            await sendWelcomeEmail(response.userGuid, locale, true);
                                            setUserGuid(response.userGuid);
                                            const mfaData = {
                                              userGuid: response.userGuid,
                                              ipAddress: readCookie("ipAddress"),
                                              loginDeviceType: getDeviceType(),
                                              userAgent: navigator.userAgent,
                                              userAgentHash: "",
                                              macAddress: "",
                                              mfaRequired: true,
                                              mfaVerified: false,
                                              visitId: readCookie("visitGuid"),
                                              tenantId: getTenantId(),
                                            };
                                            await saveMfaVerificationData(mfaData);
                                            toSetOtpTarget("mfa");
                                            // Show the SecureSimpliVerificationPopup
                                            setShowLoader("d-none");
                                            togglePsscVerificationModal(true);
                                          } else {
                                            if (
                                              (currentDomain() === DomainEnum.PDFSIMPLI && !isPSRB) ||
                                              currentDomain() === DomainEnum.WORKSIMPLI ||
                                              currentDomain() === DomainEnum.SIGNSIMPLI
                                            ) {
                                              await sendWelcomeEmail(response.userGuid, locale, true);
                                            }
                                            console.log("Process response and navigate...");
                                            NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                          }
                                        } else {
                                          console.log("error at process response...");
                                          NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                        }
                                      },
                                    );
                                  } else {
                                    setIsSocialUserExists(response.isSocialUserExists);
                                    // Direct Sign up
                                    //ToDo: No need to check domain here. It can be managed within single email function.
                                    if (isSecureSimpli) {
                                      await sendWelcomeEmail(response.userGuid, locale, true);
                                      setUserGuid(response.userGuid);
                                      const mfaData = {
                                        userGuid: response.userGuid,
                                        ipAddress: readCookie("ipAddress"),
                                        loginDeviceType: getDeviceType(),
                                        userAgent: navigator.userAgent,
                                        userAgentHash: "",
                                        macAddress: "",
                                        mfaRequired: true,
                                        mfaVerified: false,
                                        visitId: readCookie("visitGuid"),
                                        tenantId: getTenantId(),
                                      };
                                      await saveMfaVerificationData(mfaData);
                                      toSetOtpTarget("mfa");
                                      // Show the SecureSimpliVerificationPopup
                                      setShowLoader("d-none");
                                      togglePsscVerificationModal(true);
                                    } else {
                                      if (isTargetDomain) {
                                        if (!isPSRB) {
                                          await sendWelcomeEmail(response.userGuid, locale, true);
                                        }
                                        if (domain !== DomainEnum.WORKSIMPLI) {
                                          await addWelcomeDocument(response.userGuid);
                                        }
                                      }

                                      console.log(" Direct Sign up");
                                      NavigationHandler(
                                        response.userGuid,
                                        isPerquisiteBountyEnable,
                                        response.isSocialUserExists,
                                      );
                                    }
                                  }
                                })
                                .catch(() => {
                                  console.log(" Exception Sign up");
                                  NavigationHandler(response.userGuid);
                                });
                            } else {
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                              // logging
                            }
                          });
                        } else {
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                        }
                      });
                      //get address api
                    } //else part of isSocialUserExists flag
                  } else {
                    setShowLoader("d-none");
                    setdisableBtn(false);
                    setLoginError(true);
                    setLoginErrorMessage(t("generic_error.inaction_message"));
                  }
                })
                .catch((error) => {
                  setShowLoader("d-none");
                  setLoginError(true);
                  setLoginErrorMessage(error.message);
                });
            } else {
              setShowLoader("d-none");
              // toggleLoader(false);
              setdisableBtn(false);
              setLoginError(true);
              setPwd("");
              setLoginErrorMessage(
                domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI
                  ? t("sign_up.email_already_taken")
                  : t("sign_up.user_exists"),
              );
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setLoginError(true);
            setLoginErrorMessage(error.message);
            if (error.response?.data?.isAccountLocked) {
              setPasswordError(true);
              setLoginErrorMessage(`${i18next.t("sign_in.account_lock")}`);
              setPwd("");
              setdisableBtn(false);
            } else {
              setPwd("");
              setPasswordErrorMsg(
                domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.RESUMEBUILD || domain === DomainEnum.SIGNSIMPLI
                  ? t("generic_error.Invalid_login_attempt")
                  : t("sign_in.email_error_alert"),
              );
            }
          });
      } else {
        setShowLoader("d-none");
        setLoginErrorMessage(t("sign_up.facebook_invalid"));
        setLoginError(true);
      }
    }
  };

  const responseGoogle = (response, accessToken) => {
    if (!!response && !!accessToken) {
      setShowLoader("d-block");
      setEmailError(false);

      const { email, id } = response;
      const externalData = {
        createUser: {
          countryCD: readCookie("country"),
          currencyCD: readCookie("currency"),
          portalCD: getPortalCD(locale),
          parentUserGuid: "",
          firstName: "",
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(subDomainParam),
          tenantGroupId: getTenantGroupId(),
          designVersion: "reskin",
        },
        externalLoginInfo: {
          loginType: 2,
          providerKey: id,
        },
      };
      signUpAsExternalUser(externalData)
        .then((response) => {
          if (!!response) {
            let isPerquisiteBountyEnable = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
            createCookie("userguid", response.userGuid, 1);
            const authData = {
              Username: email.trim(),
              UserGuid: response.userGuid,
              Email: email.trim(),
            };
            setEmail(email.trim());
            authUser(authData, subDomainParam).then(async (authResponse) => {
              if (!!authResponse) {
                await clearIndexedDB();
                let data = {
                  Id: CreateUUID(),
                  UserId: response.userGuid,
                  VisitorId: getQueryParam("extInstalledId")
                    ? getQueryParam("extInstalledId")
                    : readCookie("visitorGuid"),
                  VisitId: readCookie("visitGuid"),
                };

                eventServicePost(data).then((eventServiceResponse) => {});
                if (response.isSocialUserExists === true) {
                  setIsSocialUserExists(response.isSocialUserExists);
                  getAddress(response.userGuid).then((addResponse) => {
                    if (!!addResponse) {
                      var addressReq = {
                        UserGuid: response.userGuid,
                        City: addResponse[0],
                        State: addResponse[1],
                        Country: addResponse[2],
                        ZipCode: addResponse[3],
                        AddressType: 0,
                        IsActive: 1,
                        TenantId: getTenantId(subDomainParam),
                        IpAddress: addResponse[4],
                      };
                      saveUserAddress(addressReq).then((addressResponse) => {
                        if (!!addressResponse) {
                          SignupSuccessEvent(response.userGuid, email.trim())
                            .then((eventTrackResponse) => {
                              if (checkQueryParams(queryParams)) {
                                setIsProcessing(true);
                                ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                  (processResponse) => {
                                    if (!!processResponse) {
                                      console.log("Process response and navigate...");
                                      if (!!isPerquisiteBountyEnable) {
                                        NavigationHandler(
                                          response.userGuid,
                                          isPerquisiteBountyEnable,
                                          response.isSocialUserExists,
                                        );
                                      } else {
                                        NavigationHandler(response.userGuid);
                                      }
                                    } else {
                                      console.log("error at process response...");
                                      setShowLoader("d-none");
                                      setdisableBtn(false);
                                      setLoginError(true);
                                      setLoginErrorMessage(t("generic_error.inaction_message"));
                                      NavigationHandler(response.userGuid);
                                    }
                                  },
                                );
                              } else {
                                // Direct Sign up
                                if (!!isPerquisiteBountyEnable) {
                                  NavigationHandler(
                                    response.userGuid,
                                    isPerquisiteBountyEnable,
                                    response.isSocialUserExists,
                                  );
                                } else {
                                  NavigationHandler(
                                    response.userGuid,
                                    isPerquisiteBountyEnable,
                                    response.isSocialUserExists,
                                  );
                                }
                              }
                            })
                            .catch(() => {
                              console.log(" Exception Sign up");
                              NavigationHandler(response.userGuid);
                            });
                        } else {
                          //if response part of saveuseraddress api
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                          // logging
                        }
                      }); //saveuseraddress api
                    } else {
                      //if response part of getaddress api
                      setShowLoader("d-none");
                      setdisableBtn(false);
                      setLoginError(true);
                      setLoginErrorMessage(t("generic_error.inaction_message"));
                    }
                  });
                  //get address api
                } else {
                  ConductABTest(response, externalData.createUser.portalCD, response.userGuid);
                  getAddress(response.userGuid).then((addResponse) => {
                    if (!!addResponse) {
                      var addressReq = {
                        UserGuid: response.userGuid,
                        City: addResponse[0],
                        State: addResponse[1],
                        Country: addResponse[2],
                        ZipCode: addResponse[3],
                        AddressType: 0,
                        IsActive: 1,
                        TenantId: getTenantId(subDomainParam),
                        IpAddress: addResponse[4],
                      };
                      saveUserAddress(addressReq).then((addressResponse) => {
                        if (!!addressResponse) {
                          SignupSuccessEvent(response.userGuid, email.trim())
                            .then(async (eventTrackResponse) => {
                              if (checkQueryParams(queryParams)) {
                                setIsProcessing(true);
                                ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                  async (processResponse) => {
                                    if (!!processResponse) {
                                      if (isSecureSimpli) {
                                        await sendWelcomeEmail(response.userGuid, locale, true);
                                        setUserGuid(response.userGuid);
                                        const mfaData = {
                                          userGuid: response.userGuid,
                                          ipAddress: readCookie("ipAddress"),
                                          loginDeviceType: getDeviceType(),
                                          userAgent: navigator.userAgent,
                                          userAgentHash: "",
                                          macAddress: "",
                                          mfaRequired: true,
                                          mfaVerified: false,
                                          visitId: readCookie("visitGuid"),
                                          tenantId: getTenantId(),
                                        };
                                        await saveMfaVerificationData(mfaData);
                                        toSetOtpTarget("mfa");
                                        // Show the SecureSimpliVerificationPopup
                                        setShowLoader("d-none");
                                        togglePsscVerificationModal(true);
                                      } else {
                                        if (
                                          (currentDomain() === DomainEnum.PDFSIMPLI && !isPSRB) ||
                                          currentDomain() === DomainEnum.WORKSIMPLI ||
                                          currentDomain() === DomainEnum.SIGNSIMPLI
                                        ) {
                                          await sendWelcomeEmail(response.userGuid, locale, true);
                                        }
                                        console.log("Process response and navigate...");
                                        NavigationHandler(response.userGuid, false);
                                      }
                                    } else {
                                      console.log("error at process response...");
                                      setShowLoader("d-none");
                                      setdisableBtn(false);
                                      setLoginError(true);
                                      setLoginErrorMessage(t("generic_error.inaction_message"));
                                      NavigationHandler(response.userGuid);
                                    }
                                  },
                                );
                              } else {
                                if (isSecureSimpli) {
                                  await sendWelcomeEmail(response.userGuid, locale, true);
                                  setUserGuid(response.userGuid);
                                  const mfaData = {
                                    userGuid: response.userGuid,
                                    ipAddress: readCookie("ipAddress"),
                                    loginDeviceType: getDeviceType(),
                                    userAgent: navigator.userAgent,
                                    userAgentHash: "",
                                    macAddress: "",
                                    mfaRequired: true,
                                    mfaVerified: false,
                                    visitId: readCookie("visitGuid"),
                                    tenantId: getTenantId(),
                                  };
                                  await saveMfaVerificationData(mfaData);
                                  toSetOtpTarget("mfa");
                                  // Show the SecureSimpliVerificationPopup
                                  setShowLoader("d-none");
                                  togglePsscVerificationModal(true);
                                } else {
                                  if (isTargetDomain) {
                                    if (!isPSRB) {
                                      await sendWelcomeEmail(response.userGuid, locale, true);
                                    }
                                    if (domain !== DomainEnum.WORKSIMPLI) {
                                      await addWelcomeDocument(response.userGuid);
                                    }
                                  }
                                  // Direct Sign up
                                  console.log(" Direct Sign up");
                                  NavigationHandler(
                                    response.userGuid,
                                    isPerquisiteBountyEnable,
                                    response.isSocialUserExists,
                                  );
                                }
                              }
                            })
                            .catch(() => {
                              console.log(" Exception Sign up");
                              NavigationHandler(response.userGuid);
                            });
                        } else {
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                          // logging
                        }
                      });
                    } else {
                      setShowLoader("d-none");
                      setdisableBtn(false);
                      setLoginError(true);
                      setLoginErrorMessage(t("generic_error.inaction_message"));
                    }
                  });
                  //get address api
                } //else part of isSocialUserExists flag
              } else {
                //if response part of authUser api
                setShowLoader("d-none");
                setdisableBtn(false);
                setLoginError(true);
                setLoginErrorMessage(t("generic_error.inaction_message"));
              }
            }); //authuser api
          } else {
            //if response part of signUpAsExternalUser api
            setShowLoader("d-none");
            // toggleLoader(false);
            setdisableBtn(false);
            setLoginError(true);
            setPwd("");
            setLoginErrorMessage(
              domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI
                ? t("sign_up.email_already_taken")
                : t("sign_up.user_exists"),
            );
          }
        })
        .catch((error) => {
          setShowLoader("d-none");
          setLoginError(true);
          setLoginErrorMessage(error.message);
          setShowLoader("d-none");
          setLoginError(true);
          setLoginErrorMessage(error.message);
          if (error.response?.data?.isAccountLocked) {
            setPasswordError(true);
            setLoginErrorMessage(`${i18next.t("sign_in.account_lock")}`);
            setPwd("");
            setdisableBtn(false);
          } else {
            setPwd("");
            setPasswordErrorMsg(
              domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI || domain === DomainEnum.RESUMEBUILD
                ? t("generic_error.Invalid_login_attempt")
                : t("sign_in.email_error_alert"),
            );
          }
        });
    } else {
      //very outside else first else
      setShowLoader("d-none");
      setLoginErrorMessage(t("sign_up.facebook_invalid"));
      setLoginError(true);
    }
  };

  const responseApple = (response, code) => {
    if (!!response && !!code) {
      setShowLoader("d-block");
      setEmailError(false);
      const { email, fullName, sub } = response;
      if (!!email) {
        const externalData = {
          createUser: {
            countryCD: readCookie("country"),
            currencyCD: readCookie("currency"),
            portalCD: getPortalCD(locale),
            parentUserGuid: "",
            firstName: fullName,
            lastName: "",
            company: "",
            title: "",
            email: email,
            password: "",
            tenantId: getTenantId(subDomainParam),
            tenantGroupId: getTenantGroupId(),
            designVersion: "reskin",
          },
          externalLoginInfo: {
            loginType: 4,
            providerKey: sub,
          },
        };
        signUpAsExternalUser(externalData)
          .then((response) => {
            if (!!response) {
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
              createCookie("userguid", response.userGuid, 1);
              const authData = {
                Username: email.trim(),
                UserGuid: response.userGuid,
                Email: email.trim(),
              };
              setEmail(email.trim());
              authUser(authData, subDomainParam)
                .then(async (authResponse) => {
                  if (!!authResponse) {
                    await clearIndexedDB();
                    let data = {
                      Id: CreateUUID(),
                      UserId: response.userGuid,
                      VisitorId: getQueryParam("extInstalledId")
                        ? getQueryParam("extInstalledId")
                        : readCookie("visitorGuid"),
                      VisitId: readCookie("visitGuid"),
                    };
                    eventServicePost(data).then((eventServiceResponse) => {});
                    if (response.isSocialUserExists === true) {
                      setIsSocialUserExists(response.isSocialUserExists);
                      getAddress(response.userGuid).then((addResponse) => {
                        if (!!addResponse) {
                          var addressReq = {
                            UserGuid: response.userGuid,
                            City: addResponse[0],
                            State: addResponse[1],
                            Country: addResponse[2],
                            ZipCode: addResponse[3],
                            AddressType: 0,
                            IsActive: 1,
                            TenantId: getTenantId(subDomainParam),
                            IpAddress: addResponse[4],
                          };
                          saveUserAddress(addressReq).then((addressResponse) => {
                            if (!!addressResponse) {
                              SignupSuccessEvent(response.userGuid, email.trim())
                                .then((eventTrackResponse) => {
                                  if (checkQueryParams(queryParams)) {
                                    setIsProcessing(true);
                                    ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                      (processResponse) => {
                                        if (!!processResponse) {
                                          console.log("Process response and navigate...");
                                          if (!!isPerquisiteBountyEnable) {
                                            NavigationHandler(
                                              response.userGuid,
                                              isPerquisiteBountyEnable,
                                              response.isSocialUserExists,
                                            );
                                          } else {
                                            NavigationHandler(response.userGuid);
                                          }
                                        } else {
                                          console.log("error at process response...");
                                          setShowLoader("d-none");
                                          setdisableBtn(false);
                                          setLoginError(true);
                                          setLoginErrorMessage(t("generic_error.inaction_message"));
                                          NavigationHandler(response.userGuid);
                                        }
                                      },
                                    );
                                  } else {
                                    // Direct Sign up
                                    if (!!isPerquisiteBountyEnable) {
                                      NavigationHandler(
                                        response.userGuid,
                                        isPerquisiteBountyEnable,
                                        response.isSocialUserExists,
                                      );
                                    } else {
                                      NavigationHandler(
                                        response.userGuid,
                                        isPerquisiteBountyEnable,
                                        response.isSocialUserExists,
                                      );
                                    }
                                  }
                                })
                                .catch(() => {
                                  console.log(" Exception Sign up");
                                  NavigationHandler(response.userGuid);
                                });
                            } else {
                              //if response part of saveuseraddress api
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                              // logging
                            }
                          }); //saveuseraddress api
                        } else {
                          //if response part of getaddress api
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                        }
                      });
                      //get address api
                    } else {
                      ConductABTest(response, externalData.createUser.portalCD, response.userGuid);
                      getAddress(response.userGuid).then((addResponse) => {
                        if (!!addResponse) {
                          var addressReq = {
                            UserGuid: response.userGuid,
                            City: addResponse[0],
                            State: addResponse[1],
                            Country: addResponse[2],
                            ZipCode: addResponse[3],
                            AddressType: 0,
                            IsActive: 1,
                            TenantId: getTenantId(subDomainParam),
                            IpAddress: addResponse[4],
                          };
                          saveUserAddress(addressReq).then((addressResponse) => {
                            if (!!addressResponse) {
                              SignupSuccessEvent(response.userGuid, email.trim())
                                .then(async (eventTrackResponse) => {
                                  if (checkQueryParams(queryParams)) {
                                    setIsProcessing(true);
                                    ProcessSignUpRequest(queryParams, response.userGuid, isPerquisiteBountyEnable).then(
                                      async (processResponse) => {
                                        if (!!processResponse) {
                                          if (isSecureSimpli) {
                                            await sendWelcomeEmail(response.userGuid, locale, true);
                                            setUserGuid(response.userGuid);
                                            const mfaData = {
                                              userGuid: response.userGuid,
                                              ipAddress: readCookie("ipAddress"),
                                              loginDeviceType: getDeviceType(),
                                              userAgent: navigator.userAgent,
                                              userAgentHash: "",
                                              macAddress: "",
                                              mfaRequired: true,
                                              mfaVerified: false,
                                              visitId: readCookie("visitGuid"),
                                              tenantId: getTenantId(),
                                            };
                                            await saveMfaVerificationData(mfaData);
                                            toSetOtpTarget("mfa");
                                            // Show the SecureSimpliVerificationPopup
                                            setShowLoader("d-none");
                                            togglePsscVerificationModal(true);
                                          } else {
                                            if (
                                              (currentDomain() === DomainEnum.PDFSIMPLI && !isPSRB) ||
                                              currentDomain() === DomainEnum.WORKSIMPLI ||
                                              currentDomain() === DomainEnum.SIGNSIMPLI
                                            ) {
                                              await sendWelcomeEmail(response.userGuid, locale, true);
                                            }
                                            console.log("Process response and navigate...");
                                            NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                          }
                                        } else {
                                          console.log("error at process response...");
                                          NavigationHandler(response.userGuid, isPerquisiteBountyEnable);
                                        }
                                      },
                                    );
                                  } else {
                                    // Direct Sign up
                                    if (isSecureSimpli) {
                                      await sendWelcomeEmail(response.userGuid, locale, true);
                                      setUserGuid(response.userGuid);
                                      const mfaData = {
                                        userGuid: response.userGuid,
                                        ipAddress: readCookie("ipAddress"),
                                        loginDeviceType: getDeviceType(),
                                        userAgent: navigator.userAgent,
                                        userAgentHash: "",
                                        macAddress: "",
                                        mfaRequired: true,
                                        mfaVerified: false,
                                        visitId: readCookie("visitGuid"),
                                        tenantId: getTenantId(),
                                      };
                                      await saveMfaVerificationData(mfaData);
                                      toSetOtpTarget("mfa");
                                      // Show the SecureSimpliVerificationPopup
                                      setShowLoader("d-none");
                                      togglePsscVerificationModal(true);
                                    } else {
                                      if (isTargetDomain) {
                                        if (!isPSRB) {
                                          await sendWelcomeEmail(response.userGuid, locale, true);
                                        }
                                        if (domain !== DomainEnum.WORKSIMPLI) {
                                          await addWelcomeDocument(response.userGuid);
                                        }
                                      }
                                      console.log(" Direct Sign up");
                                      NavigationHandler(
                                        response.userGuid,
                                        isPerquisiteBountyEnable,
                                        response.isSocialUserExists,
                                      );
                                    }
                                  }
                                })
                                .catch(() => {
                                  console.log(" Exception Sign up");
                                  NavigationHandler(response.userGuid);
                                });
                            } else {
                              setShowLoader("d-none");
                              setdisableBtn(false);
                              setLoginError(true);
                              setLoginErrorMessage(t("generic_error.inaction_message"));
                              // logging
                            }
                          });
                        } else {
                          setShowLoader("d-none");
                          setdisableBtn(false);
                          setLoginError(true);
                          setLoginErrorMessage(t("generic_error.inaction_message"));
                        }
                      });
                      //get address api
                    } //else part of isSocialUserExists flag
                  } else {
                    setShowLoader("d-none");
                    setdisableBtn(false);
                    setLoginError(true);
                    setLoginErrorMessage(t("generic_error.inaction_message"));
                  }
                })
                .catch((error) => {
                  setShowLoader("d-none");
                  setLoginError(true);
                  setLoginErrorMessage(error.message);
                });
            } else {
              setShowLoader("d-none");
              // toggleLoader(false);
              setdisableBtn(false);
              setLoginError(true);
              setPwd("");
              setLoginErrorMessage(
                domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI
                  ? t("sign_up.email_already_taken")
                  : t("sign_up.user_exists"),
              );
            }
          })
          .catch((error) => {
            setShowLoader("d-none");
            setLoginError(true);
            setLoginErrorMessage(error.message);
            if (error.response?.data?.isAccountLocked) {
              setPasswordError(true);
              setLoginErrorMessage(`${i18next.t("sign_in.account_lock")}`);
              setPwd("");
              setdisableBtn(false);
            } else {
              setPwd("");
              setPasswordErrorMsg(
                domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.SIGNSIMPLI || domain === DomainEnum.RESUMEBUILD
                  ? t("generic_error.Invalid_login_attempt")
                  : t("sign_in.email_error_alert"),
              );
            }
          });
      } else {
        setShowLoader("d-none");
        setLoginErrorMessage(t("sign_up.apple_invalid"));
        setLoginError(true);
      }
    }
  };

  const NavigationHandler = (
    validUserGuid,
    isPerquisiteBountyEnable,
    isSocialUserExists,
    isGuestUser,
    isLoggedInUser,
  ) => {
    let docid = "";
    let type = "";
    if (queryParams.has("docid")) {
      docid = queryParams.get("docid");
    }
    if (queryParams.has("type")) {
      type = queryParams.get("type");
    } else if (queryParams.has("doctype")) {
      type = queryParams.get("doctype");
    }

    if (currentDomain() === DomainEnum.RESUMEBUILD || isPSRB) {
      if (!!docid) {
        UserDocMapping(docid, validUserGuid).then((mappingResponse) => {
          if (!!docid) {
            getUserDocumentAttributes(validUserGuid, 10)
              .then((abridgedResponse) => {
                NavigationHandlerForRB(locale, docid, type, abridgedResponse.docCount);
              })
              .catch((error) => {
                NavigationHandlerForRB(locale, docid, type, 0);
              });
          } else {
            NavigationHandlerForRB(locale, docid, type, 0);
          }
        });
      } else {
        NavigationHandlerForRB(locale, docid, type, 0);
      }
    } else if (currentDomain() === DomainEnum.PDFSIMPLI) {
      if (isSecureSimpli) {
        if (isSocialUserExists) {
          NavigationHandlerForPDFsimpli(
            locale,
            isPerquisiteBountyEnable,
            isSocialUserExists,
            isGuestUser,
            isLoggedInUser,
          );
        } else {
          setShowLoader("d-none");
        }
      } else {
        NavigationHandlerForPDFsimpli(
          locale,
          isPerquisiteBountyEnable,
          isSocialUserExists,
          isGuestUser,
          isLoggedInUser,
        );
      }
    } else if (currentDomain() === DomainEnum.SIGNSIMPLI) {
      NavigationHandlerForSignSimpli(locale, "", "", 0, isPerquisiteBountyEnable, isSocialUserExists, isGuestUser);
    } else if (currentDomain() === DomainEnum.WORKSIMPLI) {
      NavigationHandlerForWorkSimpli(locale, isPerquisiteBountyEnable, isSocialUserExists, isGuestUser);
    } else if (currentDomain() === DomainEnum.LEGALSIMPLI) {
      NavigationHandlerForLegalSimpli(isPerquisiteBountyEnable, isSocialUserExists, isGuestUser, isLoggedInUser);
    }
  };

  const NavigationHandlerForRB = (locale, docGuid, type, numberOfDocs) => {
    let urlPrefix = "";
    let urlPost = "";
    if (currentDomain() === DomainEnum.RESUMEBUILD || isPSRB) {
      urlPrefix = getResumeBuildBaseURL;
      if (isPSRB) {
        urlPrefix = getPdfSimpliBaseURL;
      }
      if (isPricingPageFlow()) {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl(), isPSRB);
        window.location.assign(urlPost);
      } else {
        // urlPrefix = getResumeBuildBaseURL;
        if (!!type && type?.toLowerCase() === "cvlt") {
          if (isPSRB) {
            // Changes for PSRB Cover letter Path
            if (!!docGuid) {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review", isPSRB, type) + "?docid=" + docGuid;
            } else if (numberOfDocs > 0) {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letters", isPSRB, type);
            } else {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "", type);
            }
          } else {
            if (!!docGuid) {
              urlPost =
                urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review", isPSRB) + "?docid=" + docGuid;
            } else if (numberOfDocs > 0) {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letters", isPSRB);
            } else {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-introduction", isPSRB);
            }
          }
        } else {
          if (!!docGuid) {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "review", isPSRB) + "?docid=" + docGuid;
          } else if (numberOfDocs > 0) {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes", isPSRB);
          } else {
            urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "introduction", isPSRB);
          }
        }
        console.log("NavigationHandlerForRB", urlPost);
        window.location.assign(urlPost);
      }
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
        navigate(pathRedirect.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };

  const NavigationHandlerForPDFsimpli = (
    locale,
    isPerquisiteBountyEnable = false,
    isSocialUserExists,
    isGuestUser,
    isLoggedInUser,
  ) => {
    let urlPrefix = "";
    let urlPost = "";
    const validUserGuid = readCookie("userguid");
    urlPrefix = getPdfSimpliBaseURL;
    if (isPricingPageFlow()) {
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
      window.location.assign(urlPost);
    } else if (isPerquisiteBountyEnable === false && !isGuestUser && !isLoggedInUser) {
      if (queryParams.has("ispdfsimpliextension")) {
        const ispdfsimpliextension = queryParams.get("ispdfsimpliextension");
        const billingPath = `billing?ispdfsimpliextension=${encodeURIComponent(ispdfsimpliextension)}`;
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, billingPath);
      } else {
        urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
      }
      window.location.assign(urlPost);
    } else {
      if (isSocialUserExists === true) {
        if (isPricingPageFlow()) {
          urlPrefix = getPdfSimpliBaseURL;
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
          window.location.assign(urlPost);
        } else if (isLoggedInUser) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
          if (queryParams?.has("querydata") && queryParams?.get("cname")?.toLowerCase() === CategoryName.IMAGE_AI) {
            urlPost += "?f=image";
          }
        }
        window.location.assign(urlPost);
      } else {
        if (!!validUserGuid && checkQueryParams(queryParams)) {
          setIsProcessing(true);
          ProcessSignInRequest(
            queryParams,
            validUserGuid,
            isPerquisiteBountyEnable,
            false,
            isGuestUser,
            locale,
            isLoggedInUser,
          ).then((processResponse) => {
            if (isPricingPageFlow()) {
              urlPrefix = getPdfSimpliBaseURL;
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
              window.location.assign(urlPost);
            } else if (isLoggedInUser) {
              if (isPerquisiteBountyEnable || isGuestUser) {
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                if (
                  queryParams?.has("querydata") &&
                  queryParams?.get("cname")?.toLowerCase() === CategoryName.IMAGE_AI
                ) {
                  urlPost += "?f=image";
                }
              } else {
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
              }
            } else {
              urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
              if (queryParams?.has("querydata") && queryParams?.get("cname")?.toLowerCase() === CategoryName.IMAGE_AI) {
                urlPost += "?f=image";
              }
            }
            window.location.assign(urlPost);
          });
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
          if (queryParams?.has("querydata") && queryParams?.get("cname")?.toLowerCase() === CategoryName.IMAGE_AI) {
            urlPost += "?f=image";
          }
          window.location.assign(urlPost);
        }
      }
    }
  };
  const NavigationHandlerForWorkSimpli = (
    locale,
    isPerquisiteBountyEnable = false,
    isSocialUserExists,
    isGuestUser,
    isLoggedInUser,
  ) => {
    let urlPrefix = "";
    let urlPost = "";
    const validUserGuid = readCookie("userguid");
    urlPrefix = getWorksimpliEndPoint;
    if (isPricingPageFlow()) {
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
      window.location.assign(urlPost);
    } else if (isPerquisiteBountyEnable === false && !isGuestUser && !isLoggedInUser) {
      console.log("Non paid user..");
      urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
      window.location.assign(urlPost);
    } else {
      if (isSocialUserExists === true) {
        if (isPricingPageFlow()) {
          urlPrefix = getPdfSimpliBaseURL;
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
          window.location.assign(urlPost);
        } else if (isLoggedInUser) {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
        }
        window.location.assign(urlPost);
      } else {
        if ((!!validUserGuid && window.location.search !== "" && queryParams.has("ofn")) || queryParams.has("evp")) {
          setIsProcessing(true);
          ProcessSignInRequest(
            queryParams,
            validUserGuid,
            isPerquisiteBountyEnable,
            false,
            isGuestUser,
            locale,
            isLoggedInUser,
          ).then((processResponse) => {
            if (!!processResponse) {
              if (isPricingPageFlow()) {
                urlPrefix = getPdfSimpliBaseURL;
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
                window.location.assign(urlPost);
              } else if (isLoggedInUser) {
                if (isPerquisiteBountyEnable || isGuestUser) {
                  urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                } else {
                  urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
                }
              } else {
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
              }
            } else {
              if (isPricingPageFlow()) {
                urlPrefix = getPdfSimpliBaseURL;
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, buildPricingPageUrl());
                window.location.assign(urlPost);
              } else if (isLoggedInUser) {
                if (isPerquisiteBountyEnable || isGuestUser) {
                  urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
                } else {
                  urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "billing/plans");
                }
              } else {
                urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
              }
            }
            window.location.assign(urlPost);
          });
        } else {
          urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "dashboard");
          window.location.assign(urlPost);
        }
      }
    }
  };

  const NavigationHandlerForSignSimpli = (
    locale,
    docId,
    type,
    numberOfDocs,
    isPerquisiteBountyEnable = false,
    isSocialUserExists,
    isGuestUser,
  ) => {
    let urlPrefix = "";
    let urlPost = "";
    if (currentDomain() === DomainEnum.SIGNSIMPLI) {
      urlPrefix = getSignSimpliBaseURL;
      if (isPerquisiteBountyEnable === false && !isGuestUser) {
        console.log("Non paid user..");
        urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "billing/plans");
        window.location.assign(urlPost);
      } //else if (!!type && type.toLowerCase() === "cvlt") {
      //   urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "cover-letter-review") + "?docid=" + docId;
      //   window.location.assign(urlPost);
      // }
      else {
        if (!!docId) {
          urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "review") + "?docid=" + docId;
          window.location.assign(urlPost);
        }
        // else if (numberOfDocs > 0) {
        //   urlPost = urlPrefix + "app" + getLinkWithLocale(locale, "resumes");
        //   window.location.assign(urlPost);
        // }
        else {
          const validUserGuid = readCookie("userguid");
          if (isSocialUserExists === true) {
            urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
            console.log("NavigationHandlerForSignsimpli", urlPost);
            window.location.assign(urlPost);
          } else {
            if (
              (!!validUserGuid && window.location.search !== "" && queryParams.has("ofn")) ||
              queryParams.has("evp")
            ) {
              setIsProcessing(true);
              ProcessSignInRequest(queryParams, validUserGuid, isPerquisiteBountyEnable, false, isGuestUser).then(
                (processResponse) => {
                  if (!!processResponse) {
                    urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
                  } else {
                    urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
                  }
                  console.log("NavigationHandlerForSignSimpliSuccess", urlPost);
                  window.location.assign(urlPost);
                },
              );
            } else {
              urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
              console.log("NavigationHandlerForSignSimpli", urlPost);
              window.location.assign(urlPost);
            }
          }
        }
      }
    } else {
      if (`${process.env.REACT_APP_ENVIRONMENT}` === "DEVELOPMENT") {
        navigate(PathRedirectDashboard.cstm);
      } else {
        redirectToDashboardWithLocale(locale);
      }
    }
  };
  const NavigationHandlerForLegalSimpli = async (
    isPerquisiteBountyEnable,
    isSocialUserExists,
    isGuestUser,
    isLoggedInUser,
  ) => {
    const docid = queryParams?.get("docid");
    const validUserGuid = readCookie("userguid");
    const uniqueName = queryParams?.get("unqn");
    let urlPost = "";
    let urlPrefix = getLegalSimpliBaseURL;
    try {
      const isuseExternalTemplate = queryParams?.get("useExternalTemplate");
      if (docid) {
        await updateUserGuid(docid, validUserGuid);
        DeleteTemplateDocId(docid, false);
        let docOperationBlobdata = getDocOperationBlobData("", validUserGuid, true, "", "", "", "", uniqueName, "");
        let reponse = await ProcessDocOperationRequest(docOperationBlobdata);
        let jobStatus = await DocOperationJobStatusWithInterval(reponse.docId);
      }
      if (isPerquisiteBountyEnable === false && !isGuestUser && !isLoggedInUser) {
        urlPost =
          urlPrefix +
          "/app" +
          getLinkWithLocale(locale, "billing/billing-transfer/?useExternalTemplate=" + isuseExternalTemplate + "");
        window.location.assign(urlPost);
      } else {
        if (isSocialUserExists === true) {
          if (isLoggedInUser) {
            await generatePDFPath(docid, validUserGuid, isuseExternalTemplate);
            urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
          } else {
            await generatePDFPath(docid, validUserGuid, isuseExternalTemplate);
            urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
          }
          window.location.assign(urlPost);
        } else {
          urlPost = urlPrefix + "/app" + getLinkWithLocale(locale, "dashboard");
          window.location.assign(urlPost);
        }
      }
    } catch (err) {
      setShowLoader("d-none");
      throw new Error("Error in navigation for LegalSimpli");
    }
  };

  const validateData = () => {
    setEmailError(false);
    setPasswordError(false);
    let errors = 0;

    let emailValidator = validateSignupEmail(emailId.trim());
    if (emailValidator.isValid === false) {
      ++errors;
      setEmailError(true);
      if (domain === DomainEnum.LEGALSIMPLI && emailId.length === 0) {
        setEmailErrorMsg(t("sign_in.error_required_message"));
      } else if (domain === DomainEnum.RESUMEBUILD) {
        setEmailErrorMsg(emailValidator.errorMessage);
      } else {
        setEmailErrorMsg(`${i18next.t("sign_in.wrong_email_format_message")}`);
      }
      setErrorCount(errors);
      setShowLoader("d-none");
    }
    let passwordValidator = validateSignupPassword(pwd.trim(), emailId.trim());
    if (passwordValidator.isValid === false) {
      ++errors;
      if (
        domain === DomainEnum.PDFSIMPLI ||
        domain === DomainEnum.RESUMEBUILD ||
        domain === DomainEnum.SIGNSIMPLI ||
        domain === DomainEnum.WORKSIMPLI
      ) {
        if (pwd.length === 0 || emailId.length === 0) {
          setPasswordErrorMsg(passwordValidator.errorMessage);
          setPasswordError(true);
        } else {
          setPasswordErrorMsg(t("generic_error.password_char_long"));
          setPasswordError(true);
        }
      } else if (domain === DomainEnum.LEGALSIMPLI && pwd.length === 0) {
        setPasswordErrorMsg(t("sign_in.error_required_message"));
        setPasswordError(true);
      } else {
        setPasswordErrorMsg(passwordValidator.errorMessage);
      }
    }
    setErrorCount(errors);
    if (errors > 0) {
      ++errors;
      setdisableBtn(false);
      return false;
    } else {
      // setdisableBtn(true);
      return true;
    }
  };
  const navigateSignIn = () => {
    navigate(signInLink);
  };
  const callBackSecureSimpliHandler = () => {
    if (currentDomain() === DomainEnum.SIGNSIMPLI) {
      NavigationHandlerForSignSimpli(locale, "", "", 0, false, isSocialUserExists, isGuestUser);
    } else {
      NavigationHandlerForPDFsimpli(locale, false, isSocialUserExists, isGuestUser, isLoggedInUser);
    }
    togglePsscVerificationModal(false);
  };
  return (
    <>
      <Header />
      <ReactLoader showloader={showLoader} isProcessing={isProcessing} />
      {/* <Loader showLoader={showLoader} toggleLoader={toggleLoader} /> */}
      {(() => {
        //const domain = currentDomain().toLowerCase();
        switch (domain) {
          case DomainEnum.PDFSIMPLI:
            return (
              <div>
                <PSRSignUP
                  onSignUp={onSignUp}
                  navigateSignIn={navigateSignIn}
                  disableBtn={disableBtn}
                  responseFacebook={responseFacebook}
                  googleLogin={googleLogin}
                  emailError={emailError}
                  errorCount={errorCount}
                  emailErrorMsg={emailErrorMsg}
                  passwordError={passwordError}
                  passwordErrorMsg={passwordErrorMsg}
                  loginError={loginError}
                  loginErrorMessage={loginErrorMessage}
                  onEmailChangeHandler={onEmailChangeHandler}
                  onPwdChangeHandler={onPwdChangeHandler}
                  onPasswordKeyPress={onPasswordKeyPress}
                  emailId={emailId}
                  pwd={pwd}
                  privacyPolicy={privacyPolicy}
                  termsOfUse={termsOfUse}
                  appleLogin={appleLogin}
                  isCaptchaVisible={isCaptchaVisible}
                  handleCaptchaSuccess={handleCaptchaSuccess}
                />
                {portalCD === "PSSC" && (
                  <div>
                    <input type="hidden" id="txOrigin" value={origin} />
                    <input type="hidden" id="txID" value={getTokenExID()} />
                    <input type="hidden" id="txTokenSchemeMFA" value={getTokenExScheme()} />
                    <input type="hidden" id="tokenExToken" value="" />
                    <input type="hidden" id="hmacMFA" value={createHmac()} />
                    <input type="hidden" id="timeStamp" value={getUTCTimeStamp()} />
                    <SecureSimpliVerificationPopup
                      psscVerificationModal={psscVerificationModal}
                      emailId={emailId}
                      pwd={pwd}
                      toSetOtpTarget={toSetOtpTarget}
                      otpTarget={otpTarget}
                      userGuid={userGuid}
                      callBackSecureSimpliHandler={callBackSecureSimpliHandler}
                      togglePsscVerificationModal={setPsscVerificationModal}
                    />
                  </div>
                )}
              </div>
            );
          case DomainEnum.WORKSIMPLI:
            return (
              <PSRSignUP
                onSignUp={onSignUp}
                navigateSignIn={navigateSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                emailError={emailError}
                errorCount={errorCount}
                emailErrorMsg={emailErrorMsg}
                passwordError={passwordError}
                passwordErrorMsg={passwordErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                onEmailChangeHandler={onEmailChangeHandler}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                emailId={emailId}
                pwd={pwd}
                privacyPolicy={privacyPolicy}
                termsOfUse={termsOfUse}
                appleLogin={appleLogin}
              />
            );
          case DomainEnum.LEGALSIMPLI:
            return (
              <LegalSimpliSignUp
                onSignUp={onSignUp}
                navigateSignIn={navigateSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                emailError={emailError}
                errorCount={errorCount}
                emailErrorMsg={emailErrorMsg}
                passwordError={passwordError}
                passwordErrorMsg={passwordErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                onEmailChangeHandler={onEmailChangeHandler}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                emailId={emailId}
                pwd={pwd}
                isCaptchaVisible={isCaptchaVisible}
                handleCaptchaSuccess={handleCaptchaSuccess}
                appleLogin={appleLogin}
                privacyPolicy={privacyPolicy}
                termsOfUse={termsOfUse}
              />
            );
          case DomainEnum.SIGNSIMPLI:
            return (
              <div>
                <SignSimpliSignUp
                  onSignUp={onSignUp}
                  navigateSignIn={navigateSignIn}
                  disableBtn={disableBtn}
                  responseFacebook={responseFacebook}
                  googleLogin={googleLogin}
                  emailError={emailError}
                  errorCount={errorCount}
                  emailErrorMsg={emailErrorMsg}
                  passwordError={passwordError}
                  passwordErrorMsg={passwordErrorMsg}
                  loginError={loginError}
                  loginErrorMessage={loginErrorMessage}
                  onEmailChangeHandler={onEmailChangeHandler}
                  onPwdChangeHandler={onPwdChangeHandler}
                  onPasswordKeyPress={onPasswordKeyPress}
                  emailId={emailId}
                  pwd={pwd}
                  privacyPolicy={privacyPolicy}
                  termsOfUse={termsOfUse}
                  appleLogin={appleLogin}
                  isCaptchaVisible={isCaptchaVisible}
                  handleCaptchaSuccess={handleCaptchaSuccess}
                />
                {isSecureSimpli && (
                  <div>
                    <input type="hidden" id="txOrigin" value={origin} />
                    <input type="hidden" id="txID" value={getTokenExID()} />
                    <input type="hidden" id="txTokenSchemeMFA" value={getTokenExScheme()} />
                    <input type="hidden" id="tokenExToken" value="" />
                    <input type="hidden" id="hmacMFA" value={createHmac()} />
                    <input type="hidden" id="timeStamp" value={getUTCTimeStamp()} />
                    <SecureSimpliVerificationPopup
                      psscVerificationModal={psscVerificationModal}
                      emailId={emailId}
                      pwd={pwd}
                      toSetOtpTarget={toSetOtpTarget}
                      otpTarget={otpTarget}
                      userGuid={userGuid}
                      callBackSecureSimpliHandler={callBackSecureSimpliHandler}
                      togglePsscVerificationModal={setPsscVerificationModal}
                    />
                  </div>
                )}
              </div>
            );
          default:
          case DomainEnum.RESUMEBUILD:
            return (
              <RBSignUp
                onSignUp={onSignUp}
                navigateSignIn={navigateSignIn}
                disableBtn={disableBtn}
                responseFacebook={responseFacebook}
                googleLogin={googleLogin}
                emailError={emailError}
                errorCount={errorCount}
                emailErrorMsg={emailErrorMsg}
                passwordError={passwordError}
                passwordErrorMsg={passwordErrorMsg}
                loginError={loginError}
                loginErrorMessage={loginErrorMessage}
                onEmailChangeHandler={onEmailChangeHandler}
                onPwdChangeHandler={onPwdChangeHandler}
                onPasswordKeyPress={onPasswordKeyPress}
                emailId={emailId}
                pwd={pwd}
                isCaptchaVisible={isCaptchaVisible}
                handleCaptchaSuccess={handleCaptchaSuccess}
              />
            );
        }
      })()}
      {domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.WORKSIMPLI || domain === DomainEnum.SIGNSIMPLI ? (
        ""
      ) : (
        <Footer />
      )}
    </>
  );
};

export default SignUp;
